import React from "react";

import styled from "styles/styled_components";
import Dropdown, { IDropdownProps } from "components/shared/dropdown";
import EmployeeDropdown, {
  IEmployeeDropdownProps,
} from "components/employee_dropdown";
import { sortType } from "interfaces/sort_type";

export enum DROPDOWN_LABEL_POSITION {
  LEFT,
  TOP,
}

interface ILabeledDropdown<T> extends IDropdownProps<T> {
  label: string;
  labelPosition?: DROPDOWN_LABEL_POSITION;
}

interface ILabeledEmployeeDropdown<T> extends IEmployeeDropdownProps<T> {
  label: string;
  labelPosition?: DROPDOWN_LABEL_POSITION;
  sortByName: () => void;
  sortStatus: sortType;
}

interface IStyledLabeledDropdownProps {
  labelPosition: DROPDOWN_LABEL_POSITION;
}

const StyledLabeledDropdown = styled("div")<IStyledLabeledDropdownProps>`
  display: ${(props) =>
    props.labelPosition === DROPDOWN_LABEL_POSITION.LEFT ? `flex` : `block`};
`;

const StyledLabel = styled("label")<IStyledLabeledDropdownProps>`
  color: ${(props) => props.theme.colors.primaryText};
  font-family: ${(props) => props.theme.text.primaryFamily};
  font-size: ${(props) => props.theme.text.size.base};
  margin-top: ${(props) => props.theme.spacing.small};
  text-align: left;
  height: ${({ theme }) => `calc(3 * ${theme.gridBase})`};
  width: ${(props) => `calc(9 * ${props.theme.gridBase})`};
  :empty {
    height: ${(props) => `calc(1.5 * ${props.theme.gridBase})`};
  }
  display: ${(props) =>
    props.labelPosition === DROPDOWN_LABEL_POSITION.LEFT ? `inline` : `block`};
`;

export default function LabeledDropdown<T>(props: ILabeledDropdown<T>) {
  const { label, labelPosition = DROPDOWN_LABEL_POSITION.LEFT } = props;
  return (
    <StyledLabeledDropdown labelPosition={labelPosition}>
      <StyledLabel labelPosition={labelPosition}>{label}</StyledLabel>
      <Dropdown<T> {...props} />
    </StyledLabeledDropdown>
  );
}

export function LabeledEmployeeDropdown<T>(props: ILabeledEmployeeDropdown<T>) {
  const { label, labelPosition = DROPDOWN_LABEL_POSITION.LEFT } = props;
  return (
    <StyledLabeledDropdown labelPosition={labelPosition}>
      <StyledLabel labelPosition={labelPosition}>{label}</StyledLabel>
      <EmployeeDropdown<T> {...props} />
    </StyledLabeledDropdown>
  );
}
